export default "__VITE_ASSET__1K4u0_sS__"